/**
 * @generated SignedSource<<82b26b417f50a36c96c708551355ddc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCreateDialog_group$data = {
  readonly id: string;
  readonly " $fragmentType": "UserCreateDialog_group";
};
export type UserCreateDialog_group$key = {
  readonly " $data"?: UserCreateDialog_group$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCreateDialog_group">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCreateDialog_group",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
};

(node as any).hash = "50d0195a4e9cdb1f89083f30b5119176";

export default node;
